import React, { Component } from 'react';
import { Button } from 'reactstrap';
import { withTrekEditInfo } from '../../../HOCs/withTrekEditInfo';
import withTrekPermission from '../../../HOCs/withTrekPermission';

class EditableButtons extends Component {
  handleClick = async () => {
    const { data, edit } = this.props;
    await edit.edit({ cardData: data, message: edit.message });
  };

  render() {
    const { edit } = this.props;
    return edit ? (
      <div className="slide-footer">
        <Button
          color="add"
          onClick={this.handleClick}
          className={edit.isLoading ? 'btn-loading' : ''}
        >
          {edit.isAdded ? 'Delete' : 'Add'}
        </Button>
      </div>
    ) : null;
  }
}

export default withTrekPermission(withTrekEditInfo(EditableButtons));



// WEBPACK FOOTER //
// ./src/screens/Places/EditableButtons/EditableButtons.js